var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/aaronphy/gitlab/lazada/node_modules/_nunjucks-loader@2.4.8@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/knowledgerate/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-knowledge-rate\">\n  ";
if(runtime.contextOrFrameLookup(context, frame, "feedback") == "UNSATISFIED") {
output += "\n  <span class=\"button rated bad\">\n    <svg class=\"icon\" aria-hidden=\"true\">\n      <use xlink:href=\"#icon-fbad\"></use>\n    </svg>\n  </span>\n  ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "feedback") == "SATISFIED") {
output += "\n  <span class=\"button rated good\">\n    <svg class=\"icon\" aria-hidden=\"true\">\n      <use xlink:href=\"#icon-fgood\"></use>\n    </svg>\n  </span>\n\n  ";
;
}
else {
output += "\n    ";
if(!runtime.contextOrFrameLookup(context, frame, "__history__")) {
output += "\n    <span class=\"button good J_Btn\">\n      <svg class=\"icon\" aria-hidden=\"true\">\n        <use xlink:href=\"#icon-good\"></use>\n      </svg>\n    </span>\n    <span class=\"button bad J_Btn\">\n      <svg class=\"icon\" aria-hidden=\"true\">\n        <use xlink:href=\"#icon-bad\"></use>\n      </svg>\n    </span>\n    ";
;
}
output += "\n  ";
;
}
;
}
output += "\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/knowledgerate/tpl.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/app/extension/knowledgerate/tpl.html
// module id = 248
// module chunks = 0 1